/**
 * @file Is an overall container for the whole app.
 */
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';

AppContainer.propTypes = {
  children: PropTypes.any,
  sx: PropTypes.object,
};

export default function AppContainer({ children, sx = {} }) {
  const theme = useTheme();
  return (
    <Container maxWidth="false" disableGutters sx={{ height: theme.custom.preferredHeight, ...sx }}>
      <Grid container spacing={0} sx={{ height: theme.custom.preferredHeight }}>
        {children}
      </Grid>
    </Container>
  );
}
